export default "__VITE_PUBLIC_ASSET__9d8b5ce5__"